import NewOrderContainer from './NewOrder.container';
import NewOrderComponent from './NewOrder.component';

// eslint-disable-next-line new-cap -- FIXME
export default NewOrderContainer(NewOrderComponent);
